// src/primate/api/keys.ts — device-code claim flow (PRI-456)

import { request } from '../../core/lib/api/client'

export interface ClaimResponse {
  object: 'api_key'
  livemode: boolean
  api_key: string
  note: string
}

/**
 * POST /v1/keys/claim/:code — authenticated with Clerk session JWT.
 * Binds the device code to the current user and mints a live key.
 * The key is returned to the agent polling GET /v1/keys/request/:code;
 * this response confirms the claim succeeded (the page does not display the key).
 */
export async function claimDeviceCode(code: string): Promise<ClaimResponse> {
  return request<ClaimResponse>(`/v1/keys/claim/${code}`, { method: 'POST' })
}
